// C2S means client-to-server.
// S2C means server-to-client.

export interface InternalMessage {
  internalName: string;
}

export const S2CProgressMessageName = 'progress';
export interface S2CProgressMessage extends InternalMessage {
  operationId: string;
  progress: number;
}

export const S2CSuccessMessageName = 'success';
export interface S2CSuccessMessage extends InternalMessage {
  operationId: string;
  result: any;
}

export const S2CErrorMessageName = 'error';
export interface S2CErrorMessage extends InternalMessage {
  operationId: string;
  error: Error;
}

export const C2SCancelMessageName = 'cancel';
export interface C2SCancelMessage extends InternalMessage {
  operationId: string;
}

export const C2SExecuteMessageName = 'exec';
export interface C2SExecuteMessage extends InternalMessage {
  operationId: string;
  originalName: string;
  originalArgs: any;
}
